import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

// Read shape of one Configuration → Industries grid row (view__industries): a
// cfg.industries row plus usage_count (non-trashed accounts using that industry).
export const IndustryGridModelSchema = z
  .object({
    industries__id: z.string(),
    industries__name: z.string(),
    industries__sort_order: z.number().nullish(),
    industries__usage_count: z.number(),
    industries__date_modified: z.string()
  })
  .strict()

export const IndustryGridModelFields = makeFieldKeys(IndustryGridModelSchema)

export type IndustryGridModel = z.infer<typeof IndustryGridModelSchema>

export function validateIndustryGridModel(data: unknown): IndustryGridModel {
  try {
    return validateWithZodSchema(IndustryGridModelSchema, data, 'industry grid model')
  } catch (error) {
    throw new Error(`Industry grid model validation failed: ${error}`)
  }
}
